export default __webpack_public_path__ + "static/media/UI_Main.min.7cbd9c64.png";